const setVars = () => {
  const doc = document.documentElement
  const header = document.querySelector('.header')
  const headerBar = document.querySelector('.header-bar')

  const appHeight = () => {
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
  const headerHeight = () => {
    doc.style.setProperty('--header-height', `${header.clientHeight}px`)
  }
  const headerBarHeight = () => {
    doc.style.setProperty('--header-bar-height', `${headerBar.clientHeight}px`)
  }
  const scrollbarWidth = () => {
    doc.style.setProperty('--scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`)
  }
  
  scrollbarWidth()
  appHeight()

  if (header) {
    headerHeight()

    if (headerBar) {
      headerBarHeight()
    }
  }
}
setVars()
window.addEventListener('resize', setVars)